import {SupportedNetwork} from '../types';

// Dynamic specific. Not Solana official chain IDs
// https://www.dynamic.xyz/docs/react-sdk/token-balances#svm-networks
export const getDynamicSolanaChainIdFromNetwork = (
  network: SupportedNetwork,
  mainnet = true,
): number => {
  if (network !== 'solana') {
    throw new Error(`Unsupported network: ${network}`);
  }
  return mainnet ? 101 : 103;
};
